import { Component, OnInit, Input, Injector } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { FindControlIdService } from 'webcommon/legacy-common';
import { ApAlertService, ApBaseModalComponent } from 'webcommon/core-ui';
import { FcListValidationService } from '../../generic/fc-list-validation/fc-list-validation.service';
import { FcMapNetworkResponse } from 'webcommon/shared';
import { MapInsuranceNetworkService } from './map-insurance-network.service';

@Component({
    providers: [ApAlertService, FcListValidationService],
    selector: 'ap-map-insurance-network-modal',
    styleUrls: ['./map-insurance-network.component.less'],
    templateUrl: './map-insurance-network.component.html',
})
export class MapInsuranceNetworkModalComponent extends ApBaseModalComponent<boolean> implements OnInit {
    @Input() baseId: string;
    @Input() isMapByProvider: boolean;
    @Input() providedInsurancePlanUid?: string;

    public isOpenedAsModal = true;
    public selectedToProviderPks: string[] = [];
    public selectedInsurancePlanPks: string[] = [];
    public isSubmitted = false;

    // Form Controls
    public toProviderUidControl = new FormControl(['']);
    public insurancePlanUidControl = new FormControl(['']);

    public form: FormGroup = new FormGroup({
        providersUid: this.toProviderUidControl,
        insurancePlanUid: this.insurancePlanUidControl,
    });

    public readonly FindControlIdService = FindControlIdService;

    constructor(
        injector: Injector,
        public mapInsuranceNetworkService: MapInsuranceNetworkService,
    ) {
        super(injector);
    }

    override ngOnInit() {
        super.ngOnInit();
        this.populateProviderControl();
        this.populateInsurancePlanFindControl();
    }

    public onClearSelectedMappings(): void {
        if (this.selectedToProviderPks.length > 0 && this.selectedInsurancePlanPks.length > 0) {
            this.form.markAsDirty();
        }
        this.selectedToProviderPks = [];
    }

    public onClearAllMappings(): void {
        this.selectedToProviderPks = [];
        this.selectedInsurancePlanPks = [];
    }

    public onMapBy(): void {
        this.isMapByProvider = !this.isMapByProvider;
    }

    public disableSaveButton(): boolean {
        return this.mapInsuranceNetworkService
            .disableSaveButton(this.isOpenedAsModal, this.form, this.selectedToProviderPks, this.selectedInsurancePlanPks);
    }

    private populateProviderControl(): void {
        if (this.isOpenedAsModal && this.providedInsurancePlanUid) {
            this.mapInsuranceNetworkService
                .getNetworkProviderItems(FindControlIdService.ViewPayerPlan, this.providedInsurancePlanUid)
                .pipe(this.takeUntilDestroy())
                .subscribe((providers: string[]) => {
                    if (providers) {
                        this.selectedToProviderPks = providers;
                    }
                });
        } else {
            this.selectedToProviderPks = [];
        }
    }

    private populateInsurancePlanFindControl(): void {
        if (this.providedInsurancePlanUid) {
            this.selectedInsurancePlanPks = [this.providedInsurancePlanUid];
        } else {
            this.selectedInsurancePlanPks = [];
        }
    }

    public onProviderDataPopulate() {
        // method required to add as we use the same html template,
        // as for now no functionality has to be added for modals here
        return;
    }

    public onInsurancePlanDataPopulate() {
        // method required to add as we use the same html template,
        // as for now no functionality has to be added for modals here
        return;
    }

    public onCancel() {
        super.closeModal(false);
    }

    public onSave(): void {
        this.isSubmitted = true;
        if (this.isOpenedAsModal && this.providedInsurancePlanUid && this.providedInsurancePlanUid.length > 0) {
            this.mapInsuranceNetworkService.updateNetworkItems(FindControlIdService.ViewPayerPlan,
                this.providedInsurancePlanUid,
                this.selectedToProviderPks)
                .pipe(this.takeUntilDestroy())
                .subscribe((response: FcMapNetworkResponse) => {
                    if (response.IsSuccess) {
                        super.closeModal(true);
                    }
                });
        } else {
            super.closeModal(true);
        }
    }
}
